import { MatDialogConfig } from '@angular/material/dialog';
import { getStaticMessage } from './localization';
import { StaticMessage, dynamicTextPlaceholder } from '@shared/enums';

export const Constants = {
  State: {
    StoreKeyPrefix: 'dpr_',
  },
  ReservedExpressions: [
    'comment',
    'date',
    'is current revision',
    'is locked',
    'iscurrentrevision',
    'islocked',
    'name',
    'remarks',
    'revision',
    'summary',
    'value',
  ],
  ArithmeticOperators: ['+', '-', '*', '/', '(', ')'],
  DropDownOption: {
    chooseOption: 'None',
  },
  DialogOptions: {
    disableClose: true,
    position: { top: 'var(--default-modal-top)' },
    autoFocus: true,
    restoreFocus: false,
    closeOnNavigation: true,
  } as MatDialogConfig<any>,
  FileSize: {
    MB: 1024 * 1024,
  },
  AttachmentFileUploadConfig: {
    multiple: true,
    sizeLimit: 5 * 1024 * 1024,
    imageSizeLimit: 5 * 1024 * 1024,
    sizeType: 'MB',
    sizeLimitMessage: getStaticMessage(StaticMessage.MaxLimitMessage)
      .replace(dynamicTextPlaceholder, '5')
      .replace(dynamicTextPlaceholder, 'MB'),
  },
  ImportFileUploadConfig: {
    isNoServerUpload: true,
    accept: '.xlsx, .csv',
    multiple: false,
    sizeLimit: 5 * 1024 * 1024,
    sizeType: 'MB',
    sizeLimitMessage: getStaticMessage(StaticMessage.MaxLimitMessage)
      .replace(dynamicTextPlaceholder, '5')
      .replace(dynamicTextPlaceholder, 'MB'),
  },
  NumericOptions: {
    maxConsumables: 999999999999.99,
    minConsumables: -99999999999.99,
    maxWeather: 999999999999.99,
    minWeather: -99999999999.99,
    maxPersonnelWorkedHours: 999999999999,
    maxActivitiesCustomData: 99999999999999,
    maxTableOfColumns: 999999999999.99,
    minTableOfColumns: -999999999999.99,
    intMax: Math.pow(2, 31) - 1,
    intMin: -Math.pow(2, 31),
    minPercentage: 0,
    maxPercentage: 100,
  },
  FieldLimits: {
    maxDprTabCustomNameLength: 50,
    maxStatusTrackerSubTabNameLimit: 50,
    maxApprovalCustomNameLength: 200,
    maxExternalPartyCommentCustomNameLength: 200,
    maxConfigurableCustomDataNameLength: 200,
    maxTextEditComponentLimit: 200,
    maxFreeTextDataTypeLimit: 300,
    maxSummaryLabelTextLimit: 50,
    maxGridCommentLength: 1000,
    maxCommentLength: 2000,
    maxSummaryCommentLength: 5000,
  },
  RowLimits: {
    maxColumnGroupCountLimit: 100,
    maxColumnCountLimit: 20,
    maxRowGroupCountLimit: 100,
    maxRowCountLimit: 50,
    maxStatusTrackerLimit: 20,
    maxTableOfColumnsLimit: 20,
    maxFreeTextFieldsLimit: 20,
    maxActivityCountLimit: 500,
  },
  ForbiddenExtensionsList: [
    'exe',
    'zip',
    'rar',
    'bat',
    'com',
    'cmd',
    'inf',
    'ipa',
    'osx',
    'pif',
    'run',
    'whs',
    'msi',
    'ahk',
    'apk',
    'sk',
    'jar',
    'bms',
    '0xe',
    'xbe',
    'workflow',
    'bin',
    'elf',
    '8ck',
    'air',
    'ac',
    'appimage',
    'xap',
    'app',
    'gadget',
    'u3p',
    'widget',
    'out',
    'tpk',
    'inf1',
    'ins',
    'inx',
    'vsix',
    'bak',
    'arc',
    'arj',
    'as',
    'b64',
    'btoa',
    'bz',
  ],
  DefaultValues: {
    allValue: 'ALL',
  },
  DateTime: {
    MaxConfigurableDate: '2038-01-19T00:00:00Z',
    MinConfigurableDate: '1970-01-01T00:00:00Z',
  },
};
